import { ChevronRightBulletIcon } from '@mybridge/icons/ChevronRightBullet';
import { Button } from '@mybridge/ui/button';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Box, HStack, Stack } from '@mybridge/ui/layout';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { useContext, useMemo, useCallback, useEffect } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { getUserFullName } from 'v4/lib/commons';

export const NetworkBlockUserModal = ({ ...props }) => {
  const { selectedUser, blockUserLoading, blockUser, setSelectedUser } =
    useContext(MyNetworkContext);
  const { t } = useTranslator();

  // Debug log to see what user is selected
  // useEffect(() => {

  // }, [selectedUser]);

  const blockCons = useMemo(() => [
    {
      title: t('reportBlock.seeYourPostsOnTimeline') || 'See your posts on your timeline',
    },
    {
      title: t('reportBlock.tagYou') || 'Tag you',
    },
    {
      title: t('reportBlock.inviteYouToEventsOrGroups') || 'Invite you to events or groups',
    },
    {
      title: t('reportBlock.messageYou') || 'Message you',
    },
    {
      title: t('reportBlock.addYouAsAFriend') || 'Add you as a friend',
    },
    {
      title: `${t('reportBlock.blockingWillUnfriendPart1') || "If you're friends, blocking"} ${getUserFullName(selectedUser)} ${t('reportBlock.blockingWillUnfriendPart3') || "will also unfriend this user."}`,
    },
    {
      title:
        `${t('reportBlock.limitSharing') || "If you want to limit what you share with"} ${getUserFullName(selectedUser)}, ${t('reportBlock.seeLessOfThem') || "or see less of them, you can choose to take a break from them."}`,
    },
  ], [selectedUser, t]);

  const handleBlockUser = useCallback(async() => {
    if (selectedUser?.id) {
      await blockUser(selectedUser);
      if(props?.refreshFn){
        props?.refreshFn?.();
      }
    }
  }, [selectedUser,blockUser, props]);

  const handleClose = useCallback(() => {
    setSelectedUser(null);
    props?.onClose?.();
  }, [setSelectedUser, props]);

  // Don't render if no user is selected
  if (!selectedUser) {
    return null;
  }

  return (
    <>
      <Modal size="xl" {...props} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <ModalCloseButton />
            {t('profileNetwork.block') || "Block"} {getUserFullName(selectedUser)}
          </ModalHeader>
          <ModalBody>
            <Stack>
              <Stack>
                <Text>
                  {selectedUser?.first_name} {t('reportBlock.willNoLongerBeAbleTo') || "will no longer be able to"}:
                </Text>
              </Stack>

              <Stack spacing={4}>
                {blockCons?.map?.((brr, index) => (
                  <HStack key={index} alignItems="flex-start">
                    <Box flexShrink={0} pt={1}>
                      <ChevronRightBulletIcon />
                    </Box>
                    <Text>{brr?.title}</Text>
                  </HStack>
                ))}
              </Stack>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <HStack justifyContent="flex-end">
              <Button onClick={handleClose} variant="secondary" borderRadius="full">
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                onClick={handleBlockUser}
                variant="primary"
                borderRadius="full"
                isLoading={blockUserLoading}
                disabled={!selectedUser?.id}
              >
                {t('profileNetwork.block') || "Block"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
